import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility.js';

const initialState = {
    error: false,
    loading: false,
    uploaded: false,
    percent: 0,
    details: {}
};

/* ------------------ Design Upload ------------------- */
const helpersDesignuploadStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, uploaded: false, percent: 0, details: {} } );
};

const helpersDesignuploadSuccess = ( state, action ) => {
    return updateObject( state, {
        loading: false,
        error: false,
        uploaded: true,
        details: action.details
    } );
};

const helpersDesignuploadFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const helpersDesignuploadReset = ( state, action ) => {
    return updateObject( state, { uploaded: false, error: false, details: {}, percent: 0 } );
};

const helpersDesignuploadProgress = ( state, action ) => {
    return updateObject( state, { percent: action.percent } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.HELPERS_DESIGNUPLOAD_START: return helpersDesignuploadStart( state, action );
        case actionTypes.HELPERS_DESIGNUPLOAD_SUCCESS: return helpersDesignuploadSuccess( state, action );
        case actionTypes.HELPERS_DESIGNUPLOAD_FAIL: return helpersDesignuploadFail( state, action );
        case actionTypes.HELPERS_DESIGNUPLOAD_RESET: return helpersDesignuploadReset( state, action );
        case actionTypes.HELPERS_DESIGNUPLOAD_PROGRESS: return helpersDesignuploadProgress( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/helpers/design.js